import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Fetch and update the list of Users.
 *
 * @private
 */
export const fetchUsersList = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/user/fetchUsersList', async (_, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/user/fetchUsersList', {
      category: 'rpc',
      type: 'rpc/user/fetchUsersList',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      'Unknown error on {fetchUsersList}',
      { tags: ['rpc', 'user'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Fetch Users List Failed',
      error,
    })
  }
})
